<template>
  <path
    d="M20 2.00018H4C2.9 2.00018 2 2.90018 2 4.00018V22.0002L6 18.0002H20C21.1 18.0002 22 17.1002 22 16.0002V4.00018C22 2.90018 21.1 2.00018 20 2.00018ZM6 14.0002V11.5302L12.88 4.65018C13.08 4.45018 13.39 4.45018 13.59 4.65018L15.36 6.42018C15.56 6.62018 15.56 6.93018 15.36 7.13018L8.47 14.0002H6ZM17 14.0002H10.5L12.5 12.0002H17C17.55 12.0002 18 12.4502 18 13.0002C18 13.5502 17.55 14.0002 17 14.0002Z"
  />
</template>
